import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

import { getCookie } from 'helpers/cookies';

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => (getCookie('accessToken') ? (
      <Component {...props} />
    ) : (
      <Redirect
        to={{
          pathname: '/home',
          state: { from: props.location },
        }}
      />
    ))}
  />
);

PrivateRoute.defaultProps = {
  location: null,
};

PrivateRoute.propTypes = {
  component: PropTypes.shape().isRequired,
  location: PropTypes.shape(),
};

export default PrivateRoute;
